import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { ButtonToolbar } from 'reactstrap';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import { DEPOSIT_MIGRATION_PATH } from '../../../../config/paths';
import { DEPOSIT_MIGRATION_FILE_STATUS } from '../../../../config/constants';
import {
  getDepositMigration,
  clearDepositMigration,
} from '../../../../actions';
import DepositMigrationBasicInformationResource from './DepositMigrationBasicInformationResource';
import DepositMigrationMovements from './DepositMigrationMovements';
import ReprocessDepositMigrationButton from './ReprocessDepositMigrationButton';

const DepositMigration = ({
  breadcrumbs,
  depositMigration,
  loading,
  match: {
    params: { id: depositMigrationId },
  },
  dispatchGetDepositMigration,
  dispatchClearDepositMigration,
}) => {
  useLayoutEffect(() => {
    dispatchGetDepositMigration({ depositMigrationId });

    return () => dispatchClearDepositMigration();
  }, []);

  let content;
  let toolbar;

  if (loading) content = <Loader />;
  else if (depositMigration.isEmpty())
    content = <NoDataResource returnPage={DEPOSIT_MIGRATION_PATH} />;
  else {
    const depositMigrationJson = depositMigration.toJS();

    content = (
      <>
        <DepositMigrationBasicInformationResource {...depositMigrationJson} />
        <hr />
        <DepositMigrationMovements depositMigrationId={depositMigrationId} />
      </>
    );

    toolbar =
      depositMigrationJson.status !==
      DEPOSIT_MIGRATION_FILE_STATUS.VOIDED.value ? (
        <ButtonToolbar className="pull-right">
          <ReprocessDepositMigrationButton
            depositMigrationId={depositMigrationJson.id}
          />
        </ButtonToolbar>
      ) : null;
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      toolbar={toolbar}
      title="Carga del estado de cuenta"
      content={content}
    />
  );
};

DepositMigration.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  depositMigration: PropTypes.instanceOf(Immutable.Map).isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  dispatchGetDepositMigration: PropTypes.func.isRequired,
  dispatchClearDepositMigration: PropTypes.func.isRequired,
};

DepositMigration.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ SalesUnit }) => ({
  breadcrumbs: [
    ...SalesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Cargas del estado de cuenta',
      href: DEPOSIT_MIGRATION_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  depositMigration: SalesUnit.DepositMigration.getIn(['current', 'content']),
  loading: !SalesUnit.DepositMigration.getIn(['current', 'activity']).isEmpty(),
});

const mapDispatchToProps = {
  dispatchGetDepositMigration: getDepositMigration,
  dispatchClearDepositMigration: clearDepositMigration,
};

export { DepositMigration };
export default connect(mapStateToProps, mapDispatchToProps)(DepositMigration);
